export const translations = {
  en: {
    indlaeg: {
      title: 'Journal',
      saveEntry: 'Save entry',
      copyEntry: 'Copy journal',
      copiedEntry: 'Copied',
      saving: 'Saving...',
      generatedNotePlaceholder: 'The generated note appears here. You can edit freely.',
      templates: 'Templates',
      loadingTemplates: 'Loading templates...',
      templatesError: 'Could not load templates. Please try again later.',
      templatesEmpty: 'No templates found.',
      selectTemplate: 'Select template',
      selectTemplatePlaceholder: 'Select template',
      selectedTemplate: 'Selected template',
      noneSelected: 'None selected',
      generatedNote: 'Generated note',
      generatingNote: 'Generating note...',
      noNoteYet: 'No note generated yet.',
      transcription: 'Transcription',
      dictation: 'Dictation',
      chooseMode: 'Choose a mode to record or transcribe.',
      startConsultation: 'Start consultation',
      stop: 'Stop',
      writeNote: 'Write note',
      writingNote: 'Writing note...',
      wordsCaptured: 'Words captured',
      selectTemplateHint: 'Select a template in the middle before writing a note.',
      recentSessions: 'Recent sessions',
      backToCurrent: 'Back to current',
      loadingSessions: 'Loading recent sessions...',
      historyError: 'Could not load recent sessions.',
      noSessions: 'No previous sessions for this client yet.',
      unknownClient: 'Unknown client',
      untitled: 'Untitled',
      active: 'Active',
      session: 'Session',
      journalNote: 'Journal note',
      assistantTitle: 'Selma Assistant',
      assistantClose: 'Close Selma assistant panel',
      assistantCloseShort: 'Close assistant',
      assistantPlaceholder: 'Ask Selma assistant a question...',
      emptyHint: 'No text yet — you can still ask generally.',
      templateSheetLabel: 'Selected template',
      templateNoneSelected: 'No template selected',
      templateDetailsLoading: 'Loading details...',
      templateDetailsError: 'Could not fetch template details.',
      templateDetailsEmpty: 'Select a template to see the sections.',
      templateNoSections: 'Template has no sections.',
      closeTemplate: 'Close template',
      sectionFallback: 'Section',
      backToCalendar: 'Back to booking calendar',
      agentStatus: {
        error: 'Agent: error',
        loading: 'Agent: loading',
        ready: 'Agent: ready',
        notReady: 'Agent: not ready',
      },
      errors: {
        mustBeLoggedIn: 'You must be logged in to save the entry.',
        missingClientId: 'Missing client id — could not attach the entry to a client.',
        saveFailed: 'Could not save the entry. Please try again later.',
        templateDetailsFailed: 'Could not fetch template details.',
        generationNoTranscript: 'No transcription available yet.',
        generationNeedTemplate: 'Select a template before writing a note.',
        generationFailed: 'Could not generate the note. Please try again.',
        dictationNoAudio: 'No audio recorded.',
        dictationFailed: 'Dictation failed.',
        dictationBrowserUnsupported: 'Your browser does not support recording.',
        dictationMicAccess: 'Could not access the microphone.',
        dictationStopFailed: 'Could not stop the recording.',
        recordingBrowserUnsupported: 'Your browser does not support recording.',
        recordingMissingConnection: 'Missing transcription connection.',
        recordingMicAccess: 'Could not access the microphone.',
        recordingWebsocketError: 'WebSocket error',
        agentInitFailed: 'Could not initialize the agent.',
        agentNotReady: 'Agent is not ready yet.',
        agentNoText: 'Agent returned no text',
        agentFailed: 'The agent could not respond.',
        agentTemporaryUnavailable: 'The agent is temporarily unavailable. Please try again shortly.',
        rehabNoText: 'No text found — write a note or enter text first.',
      },
      status: {
        idle: 'Idle',
        recording: 'Recording',
        uploading: 'Uploading',
        transcribing: 'Transcribing',
        done: 'Done',
        error: 'Error',
        requestingMic: 'Requesting mic…',
        connecting: 'Connecting…',
        config: 'Config',
        listening: 'Listening',
        flushing: 'Flushing',
        ended: 'Ended',
      },
    },
    assistant: {
      suggestions: 'Suggestions',
      replyTitle: 'Answer',
      youLabel: 'You',
      selmaLabel: 'Selma',
      noMessages: 'No messages yet.',
      requestExerciseSuggestions: 'Suggest evidence-based exercises',
      requestGuidelines: 'Fetch guidelines',
      requestLatestEvidence: 'Fetch latest research',
      send: 'Send',
      sending: 'Sending...',
    },
    actions: {
      missingInfo: 'Missing info',
      redFlags: 'Red flags',
      objectiveTests: 'Objective tests',
      exerciseSuggestions: 'Exercise suggestions',
      planHep: 'Plan + HEP',
      guidelines: 'Guidelines',
      latestEvidence: 'Latest evidence',
      summarizePatient: 'Summarize patient',
    },
    prompts: {
      missingInfo:
        'Find missing clinical information in the history and suggest relevant follow-up questions.',
      redFlags:
        'Identify possible red flags and what questions/actions should follow.',
      objectiveTests: 'Suggest relevant objective tests and what they can reveal.',
      exerciseSuggestions:
        'Provide exactly 3 evidence-based exercise suggestions tailored to the patient context. For each exercise include: purpose, dosage, load tolerance guidance, and progression/regression options. Keep each exercise very short and clinically usable. Use only information from the provided note and general clinical knowledge. Do not perform external web searches and do not include citations/sources.',
      planHep:
        'Propose a clinical plan with a short HEP (home exercises) and key patient points.',
      summarizePatient: 'Summarize this patient’s full history across all notes.',
    },
  },
  da: {
    indlaeg: {
      title: 'Journal',
      saveEntry: 'Gem indlæg',
      copyEntry: 'Kopiér journal',
      copiedEntry: 'Kopieret',
      saving: 'Gemmer...',
      generatedNotePlaceholder: 'Her vises det genererede notat. Du kan redigere frit.',
      templates: 'Skabeloner',
      loadingTemplates: 'Henter skabeloner...',
      templatesError: 'Kunne ikke hente skabeloner. Prøv igen senere.',
      templatesEmpty: 'Ingen skabeloner fundet.',
      selectTemplate: 'Vælg skabelon',
      selectTemplatePlaceholder: 'Vælg skabelon',
      selectedTemplate: 'Valgt skabelon',
      noneSelected: 'Ingen valgt',
      generatedNote: 'Genereret notat',
      generatingNote: 'Genererer notat...',
      noNoteYet: 'Ingen notat genereret endnu.',
      transcription: 'Transkribering',
      dictation: 'Diktering',
      chooseMode: 'Vælg en mode for at optage eller transkribere.',
      startConsultation: 'Start konsultation',
      stop: 'Stop',
      writeNote: 'Skriv notat',
      writingNote: 'Skriver notat...',
      wordsCaptured: 'Ord opfanget',
      selectTemplateHint: 'Vælg en skabelon i midten før du skriver notat.',
      recentSessions: 'Seneste sessioner',
      backToCurrent: 'Tilbage til nuværende',
      loadingSessions: 'Henter seneste sessioner...',
      historyError: 'Kunne ikke hente seneste sessioner.',
      noSessions: 'Ingen tidligere sessioner for denne borger endnu.',
      unknownClient: 'Ukendt klient',
      untitled: 'Uden titel',
      active: 'Aktiv',
      session: 'Session',
      journalNote: 'Journalnotat',
      assistantTitle: 'Selma Assistent',
      assistantClose: 'Luk Selma assistent panel',
      assistantCloseShort: 'Luk assistent',
      assistantPlaceholder: 'Stil et spørgsmål til Selma assistenten...',
      emptyHint: 'Ingen tekst endnu – du kan stadig spørge generelt.',
      templateSheetLabel: 'Valgt skabelon',
      templateNoneSelected: 'Ingen skabelon valgt',
      templateDetailsLoading: 'Henter detaljer...',
      templateDetailsError: 'Kunne ikke hente skabelondetaljer.',
      templateDetailsEmpty: 'Vælg en skabelon for at se sektionerne.',
      templateNoSections: 'Skabelonen har ingen sektioner.',
      closeTemplate: 'Luk skabelon',
      sectionFallback: 'Sektion',
      backToCalendar: 'Tilbage til bookingkalender',
      agentStatus: {
        error: 'Agent: fejl',
        loading: 'Agent: loader',
        ready: 'Agent: klar',
        notReady: 'Agent: ikke klar',
      },
      errors: {
        mustBeLoggedIn: 'Du skal være logget ind for at gemme indlæg.',
        missingClientId: 'Manglende klient-id – kunne ikke knytte indlægget til en klient.',
        saveFailed: 'Kunne ikke gemme indlægget. Prøv igen senere.',
        templateDetailsFailed: 'Kunne ikke hente skabelondetaljer.',
        generationNoTranscript: 'Ingen transskription tilgængelig endnu.',
        generationNeedTemplate: 'Vælg en skabelon før du skriver notat.',
        generationFailed: 'Kunne ikke generere notat. Prøv igen.',
        dictationNoAudio: 'Ingen lyd optaget.',
        dictationFailed: 'Diktering fejlede.',
        dictationBrowserUnsupported: 'Din browser understøtter ikke optagelse.',
        dictationMicAccess: 'Kunne ikke få adgang til mikrofonen.',
        dictationStopFailed: 'Kunne ikke stoppe optagelsen.',
        recordingBrowserUnsupported: 'Din browser understøtter ikke optagelse.',
        recordingMissingConnection: 'Manglende transskriptionsforbindelse.',
        recordingMicAccess: 'Kunne ikke få adgang til mikrofonen.',
        recordingWebsocketError: 'WebSocket fejl',
        agentInitFailed: 'Kunne ikke initialisere agenten.',
        agentNotReady: 'Agent ikke klar endnu.',
        agentNoText: 'Agent returnerede ingen tekst',
        agentFailed: 'Agenten kunne ikke svare.',
        agentTemporaryUnavailable: 'Agenten er midlertidigt utilgaengelig. Proev igen om lidt.',
        rehabNoText: 'Ingen tekst fundet – skriv et notat eller indtast tekst først.',
      },
      status: {
        idle: 'Idle',
        recording: 'Optager',
        uploading: 'Uploader',
        transcribing: 'Transskriberer',
        done: 'Færdig',
        error: 'Fejl',
        requestingMic: 'Anmoder om mikrofon…',
        connecting: 'Forbinder…',
        config: 'Konfigurerer',
        listening: 'Lytter',
        flushing: 'Afslutter',
        ended: 'Afsluttet',
      },
    },
    assistant: {
      suggestions: 'Forslag',
      replyTitle: 'Svar',
      youLabel: 'Dig',
      selmaLabel: 'Selma',
      noMessages: 'Ingen beskeder endnu.',
      requestExerciseSuggestions: 'Foreslå evidensbaseret øvelser',
      requestGuidelines: 'Hent retningslinjer',
      requestLatestEvidence: 'Hent nyeste forskning',
      send: 'Send',
      sending: 'Sender...',
    },
    actions: {
      missingInfo: 'Manglende info',
      redFlags: 'Røde flag',
      objectiveTests: 'Objektive tests',
      exerciseSuggestions: 'Øvelsesforslag',
      planHep: 'Plan + HEP',
      guidelines: 'Retningslinjer',
      latestEvidence: 'Nyeste forskning',
      summarizePatient: 'Opsummér patient',
    },
    prompts: {
      missingInfo:
        'Find manglende information',
      redFlags:
        'Identificer mulige røde flag',
      objectiveTests: 'Foreslå relevante tests',
      exerciseSuggestions:
        'Foreslaa praecis 3 evidensbaserede ovelser tilpasset patientens kontekst. For hver ovelse: formaal, dosering, belastningstolerance og progression/regression. Hold hvert punkt meget kort og klinisk anvendeligt. Brug kun oplysninger fra notatet og generel klinisk viden. Ingen ekstern websoegning og ingen kilder.',
      planHep:
        'Foreslå en klinisk plan med kort HEP (hjemmeøvelser) og nøglepunkter for patienten.',
      summarizePatient: 'Opsummér denne patients fulde historik på tværs af alle noter.',
    },
  },
  ar: {
    indlaeg: {
      title: 'السجل',
      saveEntry: 'حفظ الإدخال',
      saving: 'جارٍ الحفظ...',
      generatedNotePlaceholder: 'سيظهر الملاحظة المُولدة هنا. يمكنك التعديل بحرية.',
      templates: 'قوالب',
      loadingTemplates: 'جارٍ تحميل القوالب...',
      templatesError: 'تعذر تحميل القوالب. حاول مرة أخرى لاحقًا.',
      templatesEmpty: 'لم يتم العثور على قوالب.',
      selectTemplate: 'اختر قالبًا',
      selectTemplatePlaceholder: 'اختر قالبًا',
      selectedTemplate: 'القالب المحدد',
      noneSelected: 'غير محدد',
      generatedNote: 'ملاحظة مولدة',
      generatingNote: 'جارٍ توليد الملاحظة...',
      noNoteYet: 'لم يتم توليد ملاحظة بعد.',
      transcription: 'نسخ',
      dictation: 'إملاء',
      chooseMode: 'اختر وضعًا للتسجيل أو النسخ.',
      startConsultation: 'بدء الاستشارة',
      stop: 'إيقاف',
      writeNote: 'اكتب ملاحظة',
      writingNote: 'جارٍ كتابة الملاحظة...',
      wordsCaptured: 'عدد الكلمات',
      selectTemplateHint: 'اختر قالبًا في الوسط قبل كتابة الملاحظة.',
      recentSessions: 'الجلسات الأخيرة',
      backToCurrent: 'العودة إلى الحالية',
      loadingSessions: 'جارٍ تحميل الجلسات الأخيرة...',
      historyError: 'تعذر تحميل الجلسات الأخيرة.',
      noSessions: 'لا توجد جلسات سابقة لهذا العميل بعد.',
      unknownClient: 'عميل غير معروف',
      untitled: 'بدون عنوان',
      active: 'نشط',
      session: 'جلسة',
      journalNote: 'ملاحظة السجل',
      assistantTitle: 'مساعد سيلما',
      assistantClose: 'إغلاق لوحة مساعد سيلما',
      assistantCloseShort: 'إغلاق المساعد',
      assistantPlaceholder: 'اسأل مساعد سيلما سؤالًا...',
      emptyHint: 'لا يوجد نص بعد — يمكنك السؤال بشكل عام.',
      templateSheetLabel: 'القالب المحدد',
      templateNoneSelected: 'لم يتم اختيار قالب',
      templateDetailsLoading: 'جارٍ تحميل التفاصيل...',
      templateDetailsError: 'تعذر جلب تفاصيل القالب.',
      templateDetailsEmpty: 'اختر قالبًا لرؤية الأقسام.',
      templateNoSections: 'القالب بلا أقسام.',
      closeTemplate: 'إغلاق القالب',
      sectionFallback: 'قسم',
      backToCalendar: 'العودة إلى تقويم الحجز',
      agentStatus: {
        error: 'الوكيل: خطأ',
        loading: 'الوكيل: جارٍ التحميل',
        ready: 'الوكيل: جاهز',
        notReady: 'الوكيل: غير جاهز',
      },
      errors: {
        mustBeLoggedIn: 'يجب تسجيل الدخول لحفظ الإدخال.',
        missingClientId: 'معرّف العميل مفقود — لا يمكن ربط الإدخال بعميل.',
        saveFailed: 'تعذر حفظ الإدخال. حاول مرة أخرى لاحقًا.',
        templateDetailsFailed: 'تعذر جلب تفاصيل القالب.',
        generationNoTranscript: 'لا يوجد نسخ متاح بعد.',
        generationNeedTemplate: 'اختر قالبًا قبل كتابة الملاحظة.',
        generationFailed: 'تعذر إنشاء الملاحظة. حاول مرة أخرى.',
        dictationNoAudio: 'لم يتم تسجيل صوت.',
        dictationFailed: 'فشل الإملاء.',
        dictationBrowserUnsupported: 'متصفحك لا يدعم التسجيل.',
        dictationMicAccess: 'تعذر الوصول إلى الميكروفون.',
        dictationStopFailed: 'تعذر إيقاف التسجيل.',
        recordingBrowserUnsupported: 'متصفحك لا يدعم التسجيل.',
        recordingMissingConnection: 'اتصال النسخ مفقود.',
        recordingMicAccess: 'تعذر الوصول إلى الميكروفون.',
        recordingWebsocketError: 'خطأ WebSocket',
        agentInitFailed: 'تعذر تهيئة الوكيل.',
        agentNotReady: 'الوكيل غير جاهز بعد.',
        agentNoText: 'الوكيل لم يُرجع نصًا',
        agentFailed: 'لم يستطع الوكيل الرد.',
        rehabNoText: 'لم يتم العثور على نص — اكتب ملاحظة أو أدخل نصًا أولًا.',
      },
      status: {
        idle: 'خامل',
        recording: 'جارٍ التسجيل',
        uploading: 'جارٍ الرفع',
        transcribing: 'جارٍ النسخ',
        done: 'تم',
        error: 'خطأ',
        requestingMic: 'طلب الميكروفون…',
        connecting: 'جارٍ الاتصال…',
        config: 'تهيئة',
        listening: 'جارٍ الاستماع',
        flushing: 'جارٍ الإنهاء',
        ended: 'انتهى',
      },
    },
    assistant: {
      suggestions: 'اقتراحات',
      replyTitle: 'الإجابة',
      youLabel: 'أنت',
      selmaLabel: 'سيلما',
      noMessages: 'لا توجد رسائل بعد.',
      send: 'إرسال',
      sending: 'جارٍ الإرسال...',
    },
    actions: {
      missingInfo: 'معلومات ناقصة',
      redFlags: 'علامات حمراء',
      objectiveTests: 'اختبارات موضوعية',
      planHep: 'الخطة + التمارين المنزلية',
      summarizePatient: 'تلخيص المريض',
    },
    prompts: {
      missingInfo: 'اعثر على المعلومات السريرية الناقصة واقترح أسئلة متابعة مناسبة.',
      redFlags: 'حدد العلامات الحمراء وما هي الأسئلة/الإجراءات التالية.',
      objectiveTests: 'اقترح الاختبارات الموضوعية ذات الصلة وما الذي تكشفه.',
      planHep: 'اقترح خطة سريرية مع HEP قصيرة ونقاط أساسية للمريض.',
      summarizePatient: 'لخص التاريخ الكامل لهذا المريض عبر جميع الملاحظات.',
    },
  },
  sv: {
    indlaeg: {
      title: 'Journal',
      saveEntry: 'Spara inlägg',
      saving: 'Sparar...',
      generatedNotePlaceholder: 'Den genererade anteckningen visas här. Du kan redigera fritt.',
      templates: 'Mallar',
      loadingTemplates: 'Hämtar mallar...',
      templatesError: 'Kunde inte hämta mallar. Försök igen senare.',
      templatesEmpty: 'Inga mallar hittades.',
      selectTemplate: 'Välj mall',
      selectTemplatePlaceholder: 'Välj mall',
      selectedTemplate: 'Vald mall',
      noneSelected: 'Ingen vald',
      generatedNote: 'Genererad anteckning',
      generatingNote: 'Genererar anteckning...',
      noNoteYet: 'Ingen anteckning genererad ännu.',
      transcription: 'Transkription',
      dictation: 'Diktering',
      chooseMode: 'Välj ett läge för att spela in eller transkribera.',
      startConsultation: 'Starta konsultation',
      stop: 'Stoppa',
      writeNote: 'Skriv anteckning',
      writingNote: 'Skriver anteckning...',
      wordsCaptured: 'Ord fångade',
      selectTemplateHint: 'Välj en mall i mitten innan du skriver anteckning.',
      recentSessions: 'Senaste sessioner',
      backToCurrent: 'Tillbaka till aktuell',
      loadingSessions: 'Hämtar senaste sessioner...',
      historyError: 'Kunde inte hämta senaste sessioner.',
      noSessions: 'Inga tidigare sessioner för denna klient ännu.',
      unknownClient: 'Okänd klient',
      untitled: 'Utan titel',
      active: 'Aktiv',
      session: 'Session',
      journalNote: 'Journalanteckning',
      assistantTitle: 'Selma-assistent',
      assistantClose: 'Stäng Selma-assistentpanelen',
      assistantCloseShort: 'Stäng assistent',
      assistantPlaceholder: 'Ställ en fråga till Selma-assistenten...',
      emptyHint: 'Ingen text ännu — du kan ändå fråga generellt.',
      templateSheetLabel: 'Vald mall',
      templateNoneSelected: 'Ingen mall vald',
      templateDetailsLoading: 'Hämtar detaljer...',
      templateDetailsError: 'Kunde inte hämta malldetaljer.',
      templateDetailsEmpty: 'Välj en mall för att se sektionerna.',
      templateNoSections: 'Mallen har inga sektioner.',
      closeTemplate: 'Stäng mall',
      sectionFallback: 'Sektion',
      backToCalendar: 'Tillbaka till bokningskalender',
      agentStatus: {
        error: 'Agent: fel',
        loading: 'Agent: laddar',
        ready: 'Agent: klar',
        notReady: 'Agent: inte klar',
      },
      errors: {
        mustBeLoggedIn: 'Du måste vara inloggad för att spara inlägget.',
        missingClientId: 'Saknar klient-id – kunde inte koppla inlägget till en klient.',
        saveFailed: 'Kunde inte spara inlägget. Försök igen senare.',
        templateDetailsFailed: 'Kunde inte hämta malldetaljer.',
        generationNoTranscript: 'Ingen transkription tillgänglig ännu.',
        generationNeedTemplate: 'Välj en mall innan du skriver anteckning.',
        generationFailed: 'Kunde inte generera anteckning. Försök igen.',
        dictationNoAudio: 'Ingen ljudinspelning.',
        dictationFailed: 'Diktering misslyckades.',
        dictationBrowserUnsupported: 'Din webbläsare stöder inte inspelning.',
        dictationMicAccess: 'Kunde inte få åtkomst till mikrofonen.',
        dictationStopFailed: 'Kunde inte stoppa inspelningen.',
        recordingBrowserUnsupported: 'Din webbläsare stöder inte inspelning.',
        recordingMissingConnection: 'Saknar transkriptionsanslutning.',
        recordingMicAccess: 'Kunde inte få åtkomst till mikrofonen.',
        recordingWebsocketError: 'WebSocket-fel',
        agentInitFailed: 'Kunde inte initiera agenten.',
        agentNotReady: 'Agenten är inte klar ännu.',
        agentNoText: 'Agenten returnerade ingen text',
        agentFailed: 'Agenten kunde inte svara.',
        rehabNoText: 'Ingen text hittad – skriv en anteckning eller ange text först.',
      },
      status: {
        idle: 'Inaktiv',
        recording: 'Spelar in',
        uploading: 'Laddar upp',
        transcribing: 'Transkriberar',
        done: 'Klar',
        error: 'Fel',
        requestingMic: 'Begär mikrofon…',
        connecting: 'Ansluter…',
        config: 'Konfigurerar',
        listening: 'Lyssnar',
        flushing: 'Avslutar',
        ended: 'Avslutad',
      },
    },
    assistant: {
      suggestions: 'Förslag',
      replyTitle: 'Svar',
      youLabel: 'Du',
      selmaLabel: 'Selma',
      noMessages: 'Inga meddelanden ännu.',
      send: 'Skicka',
      sending: 'Skickar...',
    },
    actions: {
      missingInfo: 'Saknad info',
      redFlags: 'Röda flaggor',
      objectiveTests: 'Objektiva tester',
      planHep: 'Plan + HEP',
      summarizePatient: 'Sammanfatta patient',
    },
    prompts: {
      missingInfo: 'Hitta saknad klinisk information och föreslå relevanta följdfrågor.',
      redFlags: 'Identifiera möjliga röda flaggor och vilka frågor/åtgärder som bör följa.',
      objectiveTests: 'Föreslå relevanta objektiva tester och vad de kan visa.',
      planHep: 'Föreslå en klinisk plan med kort HEP och nyckelpunkter för patienten.',
      summarizePatient: 'Sammanfatta denna patients hela historik över alla anteckningar.',
    },
  },
  no: {
    indlaeg: {
      title: 'Journal',
      saveEntry: 'Lagre innlegg',
      saving: 'Lagrer...',
      generatedNotePlaceholder: 'Den genererte notatet vises her. Du kan redigere fritt.',
      templates: 'Maler',
      loadingTemplates: 'Henter maler...',
      templatesError: 'Kunne ikke hente maler. Prøv igjen senere.',
      templatesEmpty: 'Ingen maler funnet.',
      selectTemplate: 'Velg mal',
      selectTemplatePlaceholder: 'Velg mal',
      selectedTemplate: 'Valgt mal',
      noneSelected: 'Ingen valgt',
      generatedNote: 'Generert notat',
      generatingNote: 'Genererer notat...',
      noNoteYet: 'Ingen notat generert ennå.',
      transcription: 'Transkripsjon',
      dictation: 'Diktering',
      chooseMode: 'Velg en modus for å ta opp eller transkribere.',
      startConsultation: 'Start konsultasjon',
      stop: 'Stopp',
      writeNote: 'Skriv notat',
      writingNote: 'Skriver notat...',
      wordsCaptured: 'Ord fanget',
      selectTemplateHint: 'Velg en mal i midten før du skriver notat.',
      recentSessions: 'Siste økter',
      backToCurrent: 'Tilbake til nåværende',
      loadingSessions: 'Henter siste økter...',
      historyError: 'Kunne ikke hente siste økter.',
      noSessions: 'Ingen tidligere økter for denne klienten ennå.',
      unknownClient: 'Ukjent klient',
      untitled: 'Uten tittel',
      active: 'Aktiv',
      session: 'Økt',
      journalNote: 'Journalnotat',
      assistantTitle: 'Selma-assistent',
      assistantClose: 'Lukk Selma-assistentpanel',
      assistantCloseShort: 'Lukk assistent',
      assistantPlaceholder: 'Still et spørsmål til Selma-assistenten...',
      emptyHint: 'Ingen tekst ennå — du kan fortsatt spørre generelt.',
      templateSheetLabel: 'Valgt mal',
      templateNoneSelected: 'Ingen mal valgt',
      templateDetailsLoading: 'Henter detaljer...',
      templateDetailsError: 'Kunne ikke hente maldetaljer.',
      templateDetailsEmpty: 'Velg en mal for å se seksjonene.',
      templateNoSections: 'Malen har ingen seksjoner.',
      closeTemplate: 'Lukk mal',
      sectionFallback: 'Seksjon',
      backToCalendar: 'Tilbake til bookingkalender',
      agentStatus: {
        error: 'Agent: feil',
        loading: 'Agent: laster',
        ready: 'Agent: klar',
        notReady: 'Agent: ikke klar',
      },
      errors: {
        mustBeLoggedIn: 'Du må være innlogget for å lagre innlegget.',
        missingClientId: 'Mangler klient-id – kunne ikke knytte innlegget til en klient.',
        saveFailed: 'Kunne ikke lagre innlegget. Prøv igjen senere.',
        templateDetailsFailed: 'Kunne ikke hente maldetaljer.',
        generationNoTranscript: 'Ingen transkripsjon tilgjengelig ennå.',
        generationNeedTemplate: 'Velg en mal før du skriver notat.',
        generationFailed: 'Kunne ikke generere notatet. Prøv igjen.',
        dictationNoAudio: 'Ingen lyd tatt opp.',
        dictationFailed: 'Diktering mislyktes.',
        dictationBrowserUnsupported: 'Nettleseren din støtter ikke opptak.',
        dictationMicAccess: 'Kunne ikke få tilgang til mikrofonen.',
        dictationStopFailed: 'Kunne ikke stoppe opptaket.',
        recordingBrowserUnsupported: 'Nettleseren din støtter ikke opptak.',
        recordingMissingConnection: 'Mangler transkripsjonsforbindelse.',
        recordingMicAccess: 'Kunne ikke få tilgang til mikrofonen.',
        recordingWebsocketError: 'WebSocket-feil',
        agentInitFailed: 'Kunne ikke initialisere agenten.',
        agentNotReady: 'Agenten er ikke klar ennå.',
        agentNoText: 'Agenten returnerte ingen tekst',
        agentFailed: 'Agenten kunne ikke svare.',
        rehabNoText: 'Ingen tekst funnet – skriv et notat eller skriv inn tekst først.',
      },
      status: {
        idle: 'Inaktiv',
        recording: 'Tar opp',
        uploading: 'Laster opp',
        transcribing: 'Transkriberer',
        done: 'Ferdig',
        error: 'Feil',
        requestingMic: 'Ber om mikrofon…',
        connecting: 'Kobler til…',
        config: 'Konfigurerer',
        listening: 'Lytter',
        flushing: 'Avslutter',
        ended: 'Avsluttet',
      },
    },
    assistant: {
      suggestions: 'Forslag',
      replyTitle: 'Svar',
      youLabel: 'Du',
      selmaLabel: 'Selma',
      noMessages: 'Ingen meldinger ennå.',
      send: 'Send',
      sending: 'Sender...',
    },
    actions: {
      missingInfo: 'Manglende info',
      redFlags: 'Røde flagg',
      objectiveTests: 'Objektive tester',
      planHep: 'Plan + HEP',
      summarizePatient: 'Oppsummer pasient',
    },
    prompts: {
      missingInfo: 'Finn manglende klinisk informasjon og foreslå relevante oppfølgingsspørsmål.',
      redFlags: 'Identifiser mulige røde flagg og hvilke spørsmål/handlinger som bør følge.',
      objectiveTests: 'Foreslå relevante objektive tester og hva de kan avdekke.',
      planHep: 'Foreslå en klinisk plan med kort HEP og nøkkelpunkter for pasienten.',
      summarizePatient: 'Oppsummer denne pasientens fulle historikk på tvers av alle notater.',
    },
  },
  fr: {
    indlaeg: {
      title: 'Journal',
      saveEntry: 'Enregistrer la note',
      saving: 'Enregistrement...',
      generatedNotePlaceholder: 'La note générée apparaît ici. Vous pouvez la modifier librement.',
      templates: 'Modèles',
      loadingTemplates: 'Chargement des modèles...',
      templatesError: 'Impossible de charger les modèles. Réessayez plus tard.',
      templatesEmpty: 'Aucun modèle trouvé.',
      selectTemplate: 'Choisir un modèle',
      selectTemplatePlaceholder: 'Choisir un modèle',
      selectedTemplate: 'Modèle sélectionné',
      noneSelected: 'Aucun sélectionné',
      generatedNote: 'Note générée',
      generatingNote: 'Génération de la note...',
      noNoteYet: 'Aucune note générée pour l’instant.',
      transcription: 'Transcription',
      dictation: 'Dictée',
      chooseMode: 'Choisissez un mode pour enregistrer ou transcrire.',
      startConsultation: 'Démarrer la consultation',
      stop: 'Arrêter',
      writeNote: 'Rédiger une note',
      writingNote: 'Rédaction de la note...',
      wordsCaptured: 'Mots capturés',
      selectTemplateHint: 'Sélectionnez un modèle au centre avant d’écrire la note.',
      recentSessions: 'Sessions récentes',
      backToCurrent: 'Retour à la session actuelle',
      loadingSessions: 'Chargement des sessions récentes...',
      historyError: 'Impossible de charger les sessions récentes.',
      noSessions: 'Aucune session précédente pour ce client.',
      unknownClient: 'Client inconnu',
      untitled: 'Sans titre',
      active: 'Actif',
      session: 'Session',
      journalNote: 'Note de journal',
      assistantTitle: 'Assistant Selma',
      assistantClose: 'Fermer le panneau de l’assistant Selma',
      assistantCloseShort: 'Fermer l’assistant',
      assistantPlaceholder: 'Posez une question à l’assistant Selma...',
      emptyHint: 'Pas encore de texte — vous pouvez tout de même poser une question générale.',
      templateSheetLabel: 'Modèle sélectionné',
      templateNoneSelected: 'Aucun modèle sélectionné',
      templateDetailsLoading: 'Chargement des détails...',
      templateDetailsError: 'Impossible de récupérer les détails du modèle.',
      templateDetailsEmpty: 'Choisissez un modèle pour voir les sections.',
      templateNoSections: 'Le modèle ne contient aucune section.',
      closeTemplate: 'Fermer le modèle',
      sectionFallback: 'Section',
      backToCalendar: 'Retour au calendrier de réservation',
      agentStatus: {
        error: 'Agent : erreur',
        loading: 'Agent : chargement',
        ready: 'Agent : prêt',
        notReady: 'Agent : pas prêt',
      },
      errors: {
        mustBeLoggedIn: 'Vous devez être connecté pour enregistrer la note.',
        missingClientId: 'ID client manquant — impossible de lier la note à un client.',
        saveFailed: 'Impossible d’enregistrer la note. Réessayez plus tard.',
        templateDetailsFailed: 'Impossible de récupérer les détails du modèle.',
        generationNoTranscript: 'Aucune transcription disponible pour le moment.',
        generationNeedTemplate: 'Choisissez un modèle avant de rédiger une note.',
        generationFailed: 'Impossible de générer la note. Réessayez.',
        dictationNoAudio: 'Aucun audio enregistré.',
        dictationFailed: 'La dictée a échoué.',
        dictationBrowserUnsupported: 'Votre navigateur ne prend pas en charge l’enregistrement.',
        dictationMicAccess: 'Impossible d’accéder au microphone.',
        dictationStopFailed: 'Impossible d’arrêter l’enregistrement.',
        recordingBrowserUnsupported: 'Votre navigateur ne prend pas en charge l’enregistrement.',
        recordingMissingConnection: 'Connexion de transcription manquante.',
        recordingMicAccess: 'Impossible d’accéder au microphone.',
        recordingWebsocketError: 'Erreur WebSocket',
        agentInitFailed: 'Impossible d’initialiser l’agent.',
        agentNotReady: 'L’agent n’est pas encore prêt.',
        agentNoText: 'L’agent n’a renvoyé aucun texte',
        agentFailed: 'L’agent n’a pas pu répondre.',
        rehabNoText: 'Aucun texte trouvé — écrivez une note ou saisissez du texte.',
      },
      status: {
        idle: 'Inactif',
        recording: 'Enregistrement',
        uploading: 'Téléversement',
        transcribing: 'Transcription',
        done: 'Terminé',
        error: 'Erreur',
        requestingMic: 'Demande du micro…',
        connecting: 'Connexion…',
        config: 'Configuration',
        listening: 'Écoute',
        flushing: 'Finalisation',
        ended: 'Terminé',
      },
    },
    assistant: {
      suggestions: 'Suggestions',
      replyTitle: 'Réponse',
      youLabel: 'Vous',
      selmaLabel: 'Selma',
      noMessages: 'Aucun message pour le moment.',
      send: 'Envoyer',
      sending: 'Envoi...',
    },
    actions: {
      missingInfo: 'Infos manquantes',
      redFlags: 'Signaux d’alarme',
      objectiveTests: 'Tests objectifs',
      planHep: 'Plan + HEP',
      summarizePatient: 'Résumer le patient',
    },
    prompts: {
      missingInfo: 'Trouvez les informations cliniques manquantes et proposez des questions de suivi.',
      redFlags: 'Identifiez les signaux d’alarme possibles et les questions/actions associées.',
      objectiveTests: 'Suggérez des tests objectifs pertinents et ce qu’ils peuvent révéler.',
      planHep: 'Proposez un plan clinique avec un HEP court et des points clés pour le patient.',
      summarizePatient: 'Résumez l’historique complet de ce patient à travers toutes les notes.',
    },
  },
  de: {
    indlaeg: {
      title: 'Journal',
      saveEntry: 'Eintrag speichern',
      saving: 'Speichern...',
      generatedNotePlaceholder: 'Die generierte Notiz erscheint hier. Sie können frei bearbeiten.',
      templates: 'Vorlagen',
      loadingTemplates: 'Vorlagen werden geladen...',
      templatesError: 'Vorlagen konnten nicht geladen werden. Bitte später erneut versuchen.',
      templatesEmpty: 'Keine Vorlagen gefunden.',
      selectTemplate: 'Vorlage auswählen',
      selectTemplatePlaceholder: 'Vorlage auswählen',
      selectedTemplate: 'Ausgewählte Vorlage',
      noneSelected: 'Keine ausgewählt',
      generatedNote: 'Generierte Notiz',
      generatingNote: 'Notiz wird generiert...',
      noNoteYet: 'Noch keine Notiz generiert.',
      transcription: 'Transkription',
      dictation: 'Diktat',
      chooseMode: 'Wählen Sie einen Modus zum Aufnehmen oder Transkribieren.',
      startConsultation: 'Konsultation starten',
      stop: 'Stopp',
      writeNote: 'Notiz schreiben',
      writingNote: 'Notiz wird geschrieben...',
      wordsCaptured: 'Erfasste Wörter',
      selectTemplateHint: 'Wählen Sie eine Vorlage in der Mitte, bevor Sie eine Notiz schreiben.',
      recentSessions: 'Neueste Sitzungen',
      backToCurrent: 'Zur aktuellen Sitzung zurück',
      loadingSessions: 'Neueste Sitzungen werden geladen...',
      historyError: 'Neueste Sitzungen konnten nicht geladen werden.',
      noSessions: 'Noch keine früheren Sitzungen für diesen Kunden.',
      unknownClient: 'Unbekannter Kunde',
      untitled: 'Ohne Titel',
      active: 'Aktiv',
      session: 'Sitzung',
      journalNote: 'Journalnotiz',
      assistantTitle: 'Selma-Assistent',
      assistantClose: 'Selma-Assistentenpanel schließen',
      assistantCloseShort: 'Assistent schließen',
      assistantPlaceholder: 'Stellen Sie der Selma-Assistentin eine Frage...',
      emptyHint: 'Noch kein Text — Sie können dennoch allgemein fragen.',
      templateSheetLabel: 'Ausgewählte Vorlage',
      templateNoneSelected: 'Keine Vorlage ausgewählt',
      templateDetailsLoading: 'Details werden geladen...',
      templateDetailsError: 'Vorlagendetails konnten nicht geladen werden.',
      templateDetailsEmpty: 'Wählen Sie eine Vorlage, um die Abschnitte zu sehen.',
      templateNoSections: 'Die Vorlage hat keine Abschnitte.',
      closeTemplate: 'Vorlage schließen',
      sectionFallback: 'Abschnitt',
      backToCalendar: 'Zurück zum Buchungskalender',
      agentStatus: {
        error: 'Agent: Fehler',
        loading: 'Agent: lädt',
        ready: 'Agent: bereit',
        notReady: 'Agent: nicht bereit',
      },
      errors: {
        mustBeLoggedIn: 'Sie müssen angemeldet sein, um den Eintrag zu speichern.',
        missingClientId: 'Fehlende Kunden-ID — der Eintrag konnte nicht zugeordnet werden.',
        saveFailed: 'Eintrag konnte nicht gespeichert werden. Bitte später erneut versuchen.',
        templateDetailsFailed: 'Vorlagendetails konnten nicht geladen werden.',
        generationNoTranscript: 'Noch keine Transkription verfügbar.',
        generationNeedTemplate: 'Wählen Sie eine Vorlage, bevor Sie eine Notiz schreiben.',
        generationFailed: 'Notiz konnte nicht generiert werden. Bitte erneut versuchen.',
        dictationNoAudio: 'Keine Audioaufnahme.',
        dictationFailed: 'Diktat fehlgeschlagen.',
        dictationBrowserUnsupported: 'Ihr Browser unterstützt keine Aufnahme.',
        dictationMicAccess: 'Zugriff auf das Mikrofon nicht möglich.',
        dictationStopFailed: 'Aufnahme konnte nicht beendet werden.',
        recordingBrowserUnsupported: 'Ihr Browser unterstützt keine Aufnahme.',
        recordingMissingConnection: 'Fehlende Transkriptionsverbindung.',
        recordingMicAccess: 'Zugriff auf das Mikrofon nicht möglich.',
        recordingWebsocketError: 'WebSocket-Fehler',
        agentInitFailed: 'Agent konnte nicht initialisiert werden.',
        agentNotReady: 'Agent ist noch nicht bereit.',
        agentNoText: 'Agent hat keinen Text zurückgegeben',
        agentFailed: 'Agent konnte nicht antworten.',
        rehabNoText: 'Kein Text gefunden — schreiben Sie eine Notiz oder geben Sie Text ein.',
      },
      status: {
        idle: 'Inaktiv',
        recording: 'Aufnahme',
        uploading: 'Hochladen',
        transcribing: 'Transkribiert',
        done: 'Fertig',
        error: 'Fehler',
        requestingMic: 'Mikrofon wird angefordert…',
        connecting: 'Verbindung…',
        config: 'Konfiguration',
        listening: 'Hört zu',
        flushing: 'Beendet',
        ended: 'Beendet',
      },
    },
    assistant: {
      suggestions: 'Vorschläge',
      replyTitle: 'Antwort',
      youLabel: 'Du',
      selmaLabel: 'Selma',
      noMessages: 'Noch keine Nachrichten.',
      send: 'Senden',
      sending: 'Senden...',
    },
    actions: {
      missingInfo: 'Fehlende Infos',
      redFlags: 'Rote Flaggen',
      objectiveTests: 'Objektive Tests',
      planHep: 'Plan + HEP',
      summarizePatient: 'Patient zusammenfassen',
    },
    prompts: {
      missingInfo: 'Finden Sie fehlende klinische Informationen und schlagen Sie relevante Folgefragen vor.',
      redFlags: 'Identifizieren Sie mögliche rote Flaggen und passende Fragen/Maßnahmen.',
      objectiveTests: 'Schlagen Sie relevante objektive Tests und deren Nutzen vor.',
      planHep: 'Schlagen Sie einen klinischen Plan mit kurzem HEP und Schlüsselpunkten vor.',
      summarizePatient: 'Fassen Sie die vollständige Vorgeschichte dieses Patienten zusammen.',
    },
  },
  pt: {
    indlaeg: {
      title: 'Diário',
      saveEntry: 'Guardar registo',
      saving: 'A guardar...',
      generatedNotePlaceholder: 'A nota gerada aparece aqui. Pode editar livremente.',
      templates: 'Modelos',
      loadingTemplates: 'A carregar modelos...',
      templatesError: 'Não foi possível carregar os modelos. Tente novamente mais tarde.',
      templatesEmpty: 'Nenhum modelo encontrado.',
      selectTemplate: 'Selecionar modelo',
      selectTemplatePlaceholder: 'Selecionar modelo',
      selectedTemplate: 'Modelo selecionado',
      noneSelected: 'Nenhum selecionado',
      generatedNote: 'Nota gerada',
      generatingNote: 'A gerar nota...',
      noNoteYet: 'Nenhuma nota gerada ainda.',
      transcription: 'Transcrição',
      dictation: 'Ditado',
      chooseMode: 'Escolha um modo para gravar ou transcrever.',
      startConsultation: 'Iniciar consulta',
      stop: 'Parar',
      writeNote: 'Escrever nota',
      writingNote: 'A escrever nota...',
      wordsCaptured: 'Palavras capturadas',
      selectTemplateHint: 'Selecione um modelo no meio antes de escrever a nota.',
      recentSessions: 'Sessões recentes',
      backToCurrent: 'Voltar à atual',
      loadingSessions: 'A carregar sessões recentes...',
      historyError: 'Não foi possível carregar as sessões recentes.',
      noSessions: 'Ainda não há sessões anteriores para este cliente.',
      unknownClient: 'Cliente desconhecido',
      untitled: 'Sem título',
      active: 'Ativo',
      session: 'Sessão',
      journalNote: 'Nota de diário',
      assistantTitle: 'Assistente Selma',
      assistantClose: 'Fechar painel do assistente Selma',
      assistantCloseShort: 'Fechar assistente',
      assistantPlaceholder: 'Faça uma pergunta ao assistente Selma...',
      emptyHint: 'Ainda não há texto — pode perguntar de forma geral.',
      templateSheetLabel: 'Modelo selecionado',
      templateNoneSelected: 'Nenhum modelo selecionado',
      templateDetailsLoading: 'A carregar detalhes...',
      templateDetailsError: 'Não foi possível obter detalhes do modelo.',
      templateDetailsEmpty: 'Selecione um modelo para ver as secções.',
      templateNoSections: 'O modelo não tem secções.',
      closeTemplate: 'Fechar modelo',
      sectionFallback: 'Secção',
      backToCalendar: 'Voltar ao calendário de reservas',
      agentStatus: {
        error: 'Agente: erro',
        loading: 'Agente: a carregar',
        ready: 'Agente: pronto',
        notReady: 'Agente: não pronto',
      },
      errors: {
        mustBeLoggedIn: 'Tem de iniciar sessão para guardar o registo.',
        missingClientId: 'ID do cliente em falta — não foi possível associar o registo.',
        saveFailed: 'Não foi possível guardar o registo. Tente novamente mais tarde.',
        templateDetailsFailed: 'Não foi possível obter detalhes do modelo.',
        generationNoTranscript: 'Ainda não há transcrição disponível.',
        generationNeedTemplate: 'Selecione um modelo antes de escrever a nota.',
        generationFailed: 'Não foi possível gerar a nota. Tente novamente.',
        dictationNoAudio: 'Nenhum áudio gravado.',
        dictationFailed: 'O ditado falhou.',
        dictationBrowserUnsupported: 'O seu navegador não suporta gravação.',
        dictationMicAccess: 'Não foi possível aceder ao microfone.',
        dictationStopFailed: 'Não foi possível parar a gravação.',
        recordingBrowserUnsupported: 'O seu navegador não suporta gravação.',
        recordingMissingConnection: 'Ligação de transcrição em falta.',
        recordingMicAccess: 'Não foi possível aceder ao microfone.',
        recordingWebsocketError: 'Erro de WebSocket',
        agentInitFailed: 'Não foi possível inicializar o agente.',
        agentNotReady: 'O agente ainda não está pronto.',
        agentNoText: 'O agente não devolveu texto',
        agentFailed: 'O agente não conseguiu responder.',
        rehabNoText: 'Nenhum texto encontrado — escreva uma nota ou introduza texto primeiro.',
      },
      status: {
        idle: 'Inativo',
        recording: 'A gravar',
        uploading: 'A enviar',
        transcribing: 'A transcrever',
        done: 'Concluído',
        error: 'Erro',
        requestingMic: 'A pedir microfone…',
        connecting: 'A ligar…',
        config: 'Configuração',
        listening: 'A ouvir',
        flushing: 'A finalizar',
        ended: 'Terminado',
      },
    },
    assistant: {
      suggestions: 'Sugestões',
      replyTitle: 'Resposta',
      youLabel: 'Você',
      selmaLabel: 'Selma',
      noMessages: 'Nenhuma mensagem ainda.',
      send: 'Enviar',
      sending: 'A enviar...',
    },
    actions: {
      missingInfo: 'Informação em falta',
      redFlags: 'Sinais de alarme',
      objectiveTests: 'Testes objetivos',
      planHep: 'Plano + HEP',
      summarizePatient: 'Resumir paciente',
    },
    prompts: {
      missingInfo: 'Encontre informação clínica em falta e sugira perguntas de seguimento.',
      redFlags: 'Identifique possíveis sinais de alarme e quais perguntas/ações seguir.',
      objectiveTests: 'Sugira testes objetivos relevantes e o que podem revelar.',
      planHep: 'Proponha um plano clínico com HEP curto e pontos-chave para o paciente.',
      summarizePatient: 'Resuma o histórico completo deste paciente em todas as notas.',
    },
  },
  it: {
    indlaeg: {
      title: 'Diario',
      saveEntry: 'Salva nota',
      saving: 'Salvataggio...',
      generatedNotePlaceholder: 'La nota generata appare qui. Puoi modificare liberamente.',
      templates: 'Modelli',
      loadingTemplates: 'Caricamento modelli...',
      templatesError: 'Impossibile caricare i modelli. Riprova più tardi.',
      templatesEmpty: 'Nessun modello trovato.',
      selectTemplate: 'Seleziona modello',
      selectTemplatePlaceholder: 'Seleziona modello',
      selectedTemplate: 'Modello selezionato',
      noneSelected: 'Nessuno selezionato',
      generatedNote: 'Nota generata',
      generatingNote: 'Generazione della nota...',
      noNoteYet: 'Nessuna nota generata ancora.',
      transcription: 'Trascrizione',
      dictation: 'Dettatura',
      chooseMode: 'Scegli una modalità per registrare o trascrivere.',
      startConsultation: 'Avvia consultazione',
      stop: 'Stop',
      writeNote: 'Scrivi nota',
      writingNote: 'Scrittura nota...',
      wordsCaptured: 'Parole catturate',
      selectTemplateHint: 'Seleziona un modello al centro prima di scrivere la nota.',
      recentSessions: 'Sessioni recenti',
      backToCurrent: 'Torna a quella attuale',
      loadingSessions: 'Caricamento sessioni recenti...',
      historyError: 'Impossibile caricare le sessioni recenti.',
      noSessions: 'Nessuna sessione precedente per questo cliente.',
      unknownClient: 'Cliente sconosciuto',
      untitled: 'Senza titolo',
      active: 'Attivo',
      session: 'Sessione',
      journalNote: 'Nota di diario',
      assistantTitle: 'Assistente Selma',
      assistantClose: 'Chiudi pannello assistente Selma',
      assistantCloseShort: 'Chiudi assistente',
      assistantPlaceholder: 'Fai una domanda all’assistente Selma...',
      emptyHint: 'Nessun testo ancora — puoi comunque fare una domanda generale.',
      templateSheetLabel: 'Modello selezionato',
      templateNoneSelected: 'Nessun modello selezionato',
      templateDetailsLoading: 'Caricamento dettagli...',
      templateDetailsError: 'Impossibile recuperare i dettagli del modello.',
      templateDetailsEmpty: 'Seleziona un modello per vedere le sezioni.',
      templateNoSections: 'Il modello non ha sezioni.',
      closeTemplate: 'Chiudi modello',
      sectionFallback: 'Sezione',
      backToCalendar: 'Torna al calendario delle prenotazioni',
      agentStatus: {
        error: 'Agente: errore',
        loading: 'Agente: caricamento',
        ready: 'Agente: pronto',
        notReady: 'Agente: non pronto',
      },
      errors: {
        mustBeLoggedIn: 'Devi essere loggato per salvare la nota.',
        missingClientId: 'ID cliente mancante — non è stato possibile collegare la nota.',
        saveFailed: 'Impossibile salvare la nota. Riprova più tardi.',
        templateDetailsFailed: 'Impossibile recuperare i dettagli del modello.',
        generationNoTranscript: 'Nessuna trascrizione disponibile ancora.',
        generationNeedTemplate: 'Seleziona un modello prima di scrivere la nota.',
        generationFailed: 'Impossibile generare la nota. Riprova.',
        dictationNoAudio: 'Nessun audio registrato.',
        dictationFailed: 'La dettatura non è riuscita.',
        dictationBrowserUnsupported: 'Il tuo browser non supporta la registrazione.',
        dictationMicAccess: 'Impossibile accedere al microfono.',
        dictationStopFailed: 'Impossibile fermare la registrazione.',
        recordingBrowserUnsupported: 'Il tuo browser non supporta la registrazione.',
        recordingMissingConnection: 'Connessione di trascrizione mancante.',
        recordingMicAccess: 'Impossibile accedere al microfono.',
        recordingWebsocketError: 'Errore WebSocket',
        agentInitFailed: 'Impossibile inizializzare l’agente.',
        agentNotReady: 'L’agente non è ancora pronto.',
        agentNoText: 'L’agente non ha restituito testo',
        agentFailed: 'L’agente non è riuscito a rispondere.',
        rehabNoText: 'Nessun testo trovato — scrivi una nota o inserisci testo prima.',
      },
      status: {
        idle: 'Inattivo',
        recording: 'Registrazione',
        uploading: 'Caricamento',
        transcribing: 'Trascrizione',
        done: 'Fatto',
        error: 'Errore',
        requestingMic: 'Richiesta microfono…',
        connecting: 'Connessione…',
        config: 'Configurazione',
        listening: 'In ascolto',
        flushing: 'Finalizzazione',
        ended: 'Terminato',
      },
    },
    assistant: {
      suggestions: 'Suggerimenti',
      replyTitle: 'Risposta',
      youLabel: 'Tu',
      selmaLabel: 'Selma',
      noMessages: 'Nessun messaggio ancora.',
      send: 'Invia',
      sending: 'Invio...',
    },
    actions: {
      missingInfo: 'Info mancanti',
      redFlags: 'Segnali d’allarme',
      objectiveTests: 'Test obiettivi',
      planHep: 'Piano + HEP',
      summarizePatient: 'Riassumi paziente',
    },
    prompts: {
      missingInfo: 'Trova le informazioni cliniche mancanti e suggerisci domande di follow-up.',
      redFlags: 'Identifica possibili segnali d’allarme e quali domande/azioni seguire.',
      objectiveTests: 'Suggerisci test obiettivi rilevanti e cosa possono rivelare.',
      planHep: 'Proponi un piano clinico con un breve HEP e punti chiave per il paziente.',
      summarizePatient: 'Riassumi la storia completa di questo paziente in tutte le note.',
    },
  },
};
